export default __webpack_public_path__ + "static/media/frg--community-cafe.694a5965.png";